import React from 'react';
import CleanupLink from './CleanupLink';

const ServicesTransformSection = () => {
  const services = [
    {
      id: 1,
      title: 'Embroidery Digitizing',
      description: 'Transform your artwork into high-quality embroidery files with precision and detail.',
      image: '/images/embrioderyhome.jpg',
      link: '/services/embroidery-digitizing-services'
    },
    {
      id: 2,
      title: 'Vector Art & DTF',
      description: 'Professional vector conversion and DTF printing services for vibrant designs.',
      image: '/images/vectorhome.jpg',
      link: '/services/vectorization-services'
    },
    {
      id: 3,
      title: 'Web Development',
      description: 'Custom websites and web applications built with modern technologies.',
      image: '/images/webdevjpg.jpg',
      link: '/services/website-design-development-services'
    },
    {
      id: 4,
      title: 'Logo Designing',
      description: 'Creative and memorable logo designs that represent your brand identity.',
      image: '/images/logodesigning.jpg',
      link: '/services/logo-design-services'
    }
  ];

  return (
    <>
      <style>{`
        .sts-section {
          padding: 80px 0 100px;
        }

        .sts-header {
          text-align: center;
          max-width: 700px;
          margin: 0 auto 60px;
        }

        .sts-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
        }

        @media (max-width: 767px) {
          .sts-grid { grid-template-columns: 1fr; }
        }

        .sts-card {
          border-radius: 16px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 4px 24px rgba(0,37,54,0.10);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .sts-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 40px rgba(0,37,54,0.15);
        }

        .sts-card-image {
          position: relative;
          height: 340px;
          overflow: hidden;
        }

        .sts-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }

        .sts-card:hover .sts-card-image img {
          transform: scale(1.05);
        }

        .sts-card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, transparent 40%, rgba(0,37,54,0.6) 100%);
        }

        .sts-card-body {
          padding: 20px 24px 24px;
          text-align: center;
        }

        .sts-card-body h3 {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--primary-color);
          margin-bottom: 8px;
        }

        .sts-card-body p {
          font-size: 0.9rem;
          color: #5a6a7a;
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .sts-learn-more {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 0.85rem;
          font-weight: 600;
          color: #00a8cc;
          text-decoration: none;
          transition: gap 0.2s;
        }

        .sts-learn-more:hover { gap: 10px; color: #00a8cc; }
      `}</style>

      <section className="sts-section services-transform-section">
        <div className="container">

          <div className="sts-header">
            <div className="section-label-transform">Our Services</div>
            <h2 className="services-main-heading">
              Complete Digital & Creative Solutions for Modern Brands
            </h2>
            <p className="services-subtitle">
              At Grand Indigo, we combine creativity, technology, and precision to deliver solutions that elevate your brand. From stunning websites and powerful branding to expert embroidery digitizing, we turn ideas into impactful results.
            </p>
          </div>

          <div className="sts-grid">
            {services.map((service) => (
              <div key={service.id} className="sts-card">
                <div className="sts-card-image">
                  <img src={service.image} alt={service.title} loading="lazy" />
                  <div className="sts-card-overlay" />
                </div>
                <div className="sts-card-body">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <CleanupLink className="sts-learn-more" to={service.link}>
                    Learn More
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </CleanupLink>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};

export default ServicesTransformSection;